module.exports = __webpack_public_path__ + "static/assets/0ff20e4e8ba2ba2ed8a7095b99add518.gif";